export const DIALOG_DEFAULT_THEME = {
  bar: {
    minHeight: 60,
    paddingY: 12,
    background: 'background.content',
    borderWidth: 1,
    closeButtonSize: 's'
  },
  margin: 20,
  maxWidthXs: 400,
  size: {
    auto: {
      width: {
        xs: 'auto'
      },
      fullScreen: false
    },
    s: {
      width: {
        xs: '100%',
        s: '80%',
        m: '500px'
      },
      fullScreen: false
    },
    m: {
      width: {
        xs: '100%',
        m: '80%',
        l: '700px'
      },
      fullScreen: {
        xs: true,
        s: false
      }
    },
    l: {
      width: {
        xs: '100%',
        m: '80%',
        xl: '900px'
      },
      fullScreen: {
        xs: true,
        s: false
      }
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtaW5nL2NyZWF0ZVRoZW1lL2NvbXBvbmVudHMvRGlhbG9nLnRoZW1lLnRzIl0sIm5hbWVzIjpbIkRJQUxPR19ERUZBVUxUX1RIRU1FIiwiYmFyIiwibWluSGVpZ2h0IiwicGFkZGluZ1kiLCJiYWNrZ3JvdW5kIiwiYm9yZGVyV2lkdGgiLCJjbG9zZUJ1dHRvblNpemUiLCJtYXJnaW4iLCJtYXhXaWR0aFhzIiwic2l6ZSIsImF1dG8iLCJ3aWR0aCIsInhzIiwiZnVsbFNjcmVlbiIsInMiLCJtIiwibCIsInhsIl0sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLE1BQU1BLG9CQUFpQyxHQUFHO0FBQzdDQyxFQUFBQSxHQUFHLEVBQUU7QUFDREMsSUFBQUEsU0FBUyxFQUFFLEVBRFY7QUFFREMsSUFBQUEsUUFBUSxFQUFFLEVBRlQ7QUFHREMsSUFBQUEsVUFBVSxFQUFFLG9CQUhYO0FBSURDLElBQUFBLFdBQVcsRUFBRSxDQUpaO0FBS0RDLElBQUFBLGVBQWUsRUFBRTtBQUxoQixHQUR3QztBQVE3Q0MsRUFBQUEsTUFBTSxFQUFFLEVBUnFDO0FBUzdDQyxFQUFBQSxVQUFVLEVBQUUsR0FUaUM7QUFVN0NDLEVBQUFBLElBQUksRUFBRTtBQUNGQyxJQUFBQSxJQUFJLEVBQUU7QUFDRkMsTUFBQUEsS0FBSyxFQUFFO0FBQ0hDLFFBQUFBLEVBQUUsRUFBRTtBQURELE9BREw7QUFJRkMsTUFBQUEsVUFBVSxFQUFFO0FBSlYsS0FESjtBQU9GQyxJQUFBQSxDQUFDLEVBQUU7QUFDQ0gsTUFBQUEsS0FBSyxFQUFFO0FBQ0hDLFFBQUFBLEVBQUUsRUFBRSxNQUREO0FBRUhFLFFBQUFBLENBQUMsRUFBRSxLQUZBO0FBR0hDLFFBQUFBLENBQUMsRUFBRTtBQUhBLE9BRFI7QUFNQ0YsTUFBQUEsVUFBVSxFQUFFO0FBTmIsS0FQRDtBQWVGRSxJQUFBQSxDQUFDLEVBQUU7QUFDQ0osTUFBQUEsS0FBSyxFQUFFO0FBQ0hDLFFBQUFBLEVBQUUsRUFBRSxNQUREO0FBRUhHLFFBQUFBLENBQUMsRUFBRSxLQUZBO0FBR0hDLFFBQUFBLENBQUMsRUFBRTtBQUhBLE9BRFI7QUFNQ0gsTUFBQUEsVUFBVSxFQUFFO0FBQUVELFFBQUFBLEVBQUUsRUFBRSxJQUFOO0FBQVlFLFFBQUFBLENBQUMsRUFBRTtBQUFmO0FBTmIsS0FmRDtBQXVCRkUsSUFBQUEsQ0FBQyxFQUFFO0FBQ0NMLE1BQUFBLEtBQUssRUFBRTtBQUNIQyxRQUFBQSxFQUFFLEVBQUUsTUFERDtBQUVIRyxRQUFBQSxDQUFDLEVBQUUsS0FGQTtBQUdIRSxRQUFBQSxFQUFFLEVBQUU7QUFIRCxPQURSO0FBTUNKLE1BQUFBLFVBQVUsRUFBRTtBQUFFRCxRQUFBQSxFQUFFLEVBQUUsSUFBTjtBQUFZRSxRQUFBQSxDQUFDLEVBQUU7QUFBZjtBQU5iO0FBdkJEO0FBVnVDLENBQTFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRGlhbG9nVGhlbWUgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBESUFMT0dfREVGQVVMVF9USEVNRTogRGlhbG9nVGhlbWUgPSB7XG4gICAgYmFyOiB7XG4gICAgICAgIG1pbkhlaWdodDogNjAsXG4gICAgICAgIHBhZGRpbmdZOiAxMixcbiAgICAgICAgYmFja2dyb3VuZDogJ2JhY2tncm91bmQuY29udGVudCcsXG4gICAgICAgIGJvcmRlcldpZHRoOiAxLFxuICAgICAgICBjbG9zZUJ1dHRvblNpemU6ICdzJyxcbiAgICB9LFxuICAgIG1hcmdpbjogMjAsXG4gICAgbWF4V2lkdGhYczogNDAwLFxuICAgIHNpemU6IHtcbiAgICAgICAgYXV0bzoge1xuICAgICAgICAgICAgd2lkdGg6IHtcbiAgICAgICAgICAgICAgICB4czogJ2F1dG8nLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIGZ1bGxTY3JlZW46IGZhbHNlLFxuICAgICAgICB9LFxuICAgICAgICBzOiB7XG4gICAgICAgICAgICB3aWR0aDoge1xuICAgICAgICAgICAgICAgIHhzOiAnMTAwJScsXG4gICAgICAgICAgICAgICAgczogJzgwJScsXG4gICAgICAgICAgICAgICAgbTogJzUwMHB4JyxcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgICBmdWxsU2NyZWVuOiBmYWxzZSxcbiAgICAgICAgfSxcbiAgICAgICAgbToge1xuICAgICAgICAgICAgd2lkdGg6IHtcbiAgICAgICAgICAgICAgICB4czogJzEwMCUnLFxuICAgICAgICAgICAgICAgIG06ICc4MCUnLFxuICAgICAgICAgICAgICAgIGw6ICc3MDBweCcsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgICAgZnVsbFNjcmVlbjogeyB4czogdHJ1ZSwgczogZmFsc2UgfSxcbiAgICAgICAgfSxcbiAgICAgICAgbDoge1xuICAgICAgICAgICAgd2lkdGg6IHtcbiAgICAgICAgICAgICAgICB4czogJzEwMCUnLFxuICAgICAgICAgICAgICAgIG06ICc4MCUnLFxuICAgICAgICAgICAgICAgIHhsOiAnOTAwcHgnLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICAgIGZ1bGxTY3JlZW46IHsgeHM6IHRydWUsIHM6IGZhbHNlIH0sXG4gICAgICAgIH0sXG4gICAgfSxcbn07XG4iXX0=